/* ==========================================================================
   CTRL+Z — Airline Damage Cover
   Behaviour for the `ctrl-z-coverage` block of sections/product.liquid
   Markup: snippets/ctrl-z-coverage.liquid · Styles: assets/ctrl-z-coverage.css

   Scoped per block instance via [data-ctrl-z-coverage] so nothing depends on
   globally unique element IDs, and re-initialisable so the block keeps working
   after a theme-editor re-render or a Section Rendering API swap.
   ========================================================================== */
(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-ctrl-z-coverage]';
  var INIT_FLAG = 'ctrlZCoverageReady';

  function init(root) {
    if (!root || root.dataset[INIT_FLAG] === 'true') return;

    var btn = root.querySelector('[data-ctrl-z-trigger]');
    var overlay = root.querySelector('[data-ctrl-z-overlay]');
    var modal = root.querySelector('[data-ctrl-z-modal]');
    var closeBtn = root.querySelector('[data-ctrl-z-close]');
    if (!btn || !overlay || !modal) return;

    root.dataset[INIT_FLAG] = 'true';

    function openModal() {
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      if (closeBtn) closeBtn.focus();
    }

    function closeModal() {
      if (!overlay.classList.contains('is-open')) return;
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      btn.focus();
    }

    btn.addEventListener('click', openModal);
    if (closeBtn) closeBtn.addEventListener('click', closeModal);

    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) closeModal();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeModal();
    });

    // Swipe-down to dismiss (only when the sheet is scrolled to the top)
    var startY = 0;
    modal.addEventListener(
      'touchstart',
      function (event) {
        startY = event.touches[0].clientY;
      },
      { passive: true }
    );
    modal.addEventListener(
      'touchend',
      function (event) {
        if (event.changedTouches[0].clientY - startY > 60 && modal.scrollTop === 0) closeModal();
      },
      { passive: true }
    );

    // Theme editor: opening the modal when the merchant selects the block
    // makes the modal's settings previewable.
    root.addEventListener('ctrl-z:open', openModal);
    root.addEventListener('ctrl-z:close', closeModal);
  }

  function initAll(scope) {
    var container = scope && scope.querySelectorAll ? scope : document;
    if (container.matches && container.matches(ROOT_SELECTOR)) init(container);
    Array.prototype.forEach.call(container.querySelectorAll(ROOT_SELECTOR), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  // Re-init after theme-editor / Section Rendering API updates
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
  document.addEventListener('shopify:block:select', function (event) {
    initAll(event.target);
    var root = event.target.closest
      ? event.target.closest(ROOT_SELECTOR) || event.target.querySelector(ROOT_SELECTOR)
      : null;
    if (root) root.dispatchEvent(new CustomEvent('ctrl-z:open'));
  });
  document.addEventListener('shopify:block:deselect', function (event) {
    var root = event.target.closest
      ? event.target.closest(ROOT_SELECTOR) || event.target.querySelector(ROOT_SELECTOR)
      : null;
    if (root) root.dispatchEvent(new CustomEvent('ctrl-z:close'));
  });
})();
